export default __webpack_public_path__ + "static/media/sled.b9d70d87.png";